import React from "react";
import "./Subtotal.css";
import CurrencyFormat from "react-currency-format";
import { useStateValue } from "./StateProvider";

const Subtotal = () => {
	const [{ basket }, dispatch] = useStateValue();

	return (
		<div className="subtotal">
			<CurrencyFormat
				renderText={(value) => (
					<>
						<p>
							Subtotal (<strong>{basket?.length}</strong> items):
							<strong className="subtotal__strong">{value}</strong>
						</p>
						<small className="subtotal__gift">
							<input type="checkbox" /> This order contains a gift
						</small>
					</>
				)}
				decimalScale={2}
				value={basket
					.map((product) => +product.price.replaceAll(",", ""))
					.reduce((sum, val) => (sum += val), 0)}
				displayType={"text"}
				thousandSeperator={true}
				prefix={"₹ "}
			/>

			{basket.length > 0 ? (
				<div className="grid-container">
					{basket.map((item) => (
						<img className="grid-item" src={item.image} alt={item.title} />
					))}
				</div>
			) : (
				""
			)}

			<button className="checkout__button">Proceed to Checkout</button>
		</div>
	);
};

export default Subtotal;
